export const getters = {
	isWebTrackingEnabled(state) {
		return state.features?.webTracking?.enabled ?? false;
	}
};
